export enum FacilityType {
    Well_Pad = 'Well_Pad',
    Tank_Battery = 'Tank_Battery',
    Pipeline = 'Pipeline',
    Compressor_Station = 'Compressor_Station',
    Processing_Facility = 'Processing_Facility',
    Disposal_Facility = 'Disposal_Facility',
    Injection_Facility = 'Injection_Facility',
    Electrical = 'Electrical',
    Other = 'Other',
}
